'use client';
import React, { memo } from 'react';
import useApplyLogging from '../../hooks/useApplyLogging.mjs';

function IcTxtMainCategoryRealEstate(customProps) {
  const {
    fill,
    ...props
  } = customProps;
  useApplyLogging('ICON_IcTxtMainCategoryRealEstate');
  return /*#__PURE__*/React.createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 56 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 2.17998V4.47998H4.6V2.17998H2.06V10.94H15.56V2.17998H13ZM4.6 6.69998H13V8.73998H4.6V6.69998ZM0 13.08V15.4H7.52V20.38H10.08V15.4H17.6V13.08H0Z",
    fill: fill || 'black'
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7448 8.47998H34.0448V6.35998H23.4648V3.93998H33.8448V1.83998H20.9048V8.47998H26.1848V9.91998H18.6648V12.08H36.2648V9.91998H28.7448V8.47998ZM25.2448 13.44C22.2648 13.44 20.5248 14.92 20.5248 16.9C20.5248 18.9 22.2648 20.36 25.2448 20.36H29.6848C32.6848 20.36 34.4248 18.9 34.4248 16.9C34.4248 14.92 32.6848 13.44 29.6848 13.44H25.2448ZM25.7248 18.16C23.8648 18.16 23.0648 17.66 23.0648 16.88C23.0648 16.1 23.8648 15.64 25.7248 15.64H29.2248C31.0848 15.64 31.8648 16.1 31.8648 16.88C31.8648 17.66 31.0848 18.16 29.2248 18.16H25.7248Z",
    fill: fill || 'black'
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4697 1.47998H49.9097V15.3H52.4697V8.21998H55.1697V5.89998H52.4697V1.47998ZM46.9697 12.42L48.4297 10.52L43.5097 6.67998C43.8097 5.71998 43.9697 4.69998 43.9697 3.59998V2.13998H41.4697V3.59998C41.4697 6.29998 40.2297 8.63998 36.9297 10.84L38.3897 12.8C40.1897 11.6 41.5297 10.32 42.4497 8.89998L46.9697 12.42ZM40.1897 14.12V20.16H53.3497V17.84H42.7297V14.12H40.1897Z",
    fill: fill || 'black'
  }));
}
var IcTxtMainCategoryRealEstate$1 = /*#__PURE__*/memo(IcTxtMainCategoryRealEstate);

export { IcTxtMainCategoryRealEstate$1 as default };
